import { memo } from 'react';

import { useAssetModalLeftPanel } from '~/components/AssetModalV2/AssetModalLeftPanelContextProvider';
import { AssetModalLeftPanelContent } from '~/components/AssetModalV2/Content/Panel/components/AssetModalLeftPanelContent';
import { PDFOutlinePanel } from '~/components/AssetModalV2/Content/Panel/components/PDFOutlinePanel';

export const PublicAssetModalLeftPanelContent = memo(() => {
  const { isLeftContentPanelTabOpen } = useAssetModalLeftPanel();

  return (
    <AssetModalLeftPanelContent>
      {isLeftContentPanelTabOpen('pdfOutline') ? <PDFOutlinePanel /> : null}
    </AssetModalLeftPanelContent>
  );
});

PublicAssetModalLeftPanelContent.displayName = 'PublicAssetModalLeftPanelContent';
